import { render, staticRenderFns } from "./banner-web-onlytitle.vue?vue&type=template&id=3a46bf97&scoped=true"
import script from "./banner-web-onlytitle.vue?vue&type=script&lang=js"
export * from "./banner-web-onlytitle.vue?vue&type=script&lang=js"
import style0 from "./banner-web-onlytitle.vue?vue&type=style&index=0&id=3a46bf97&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a46bf97",
  null
  
)

export default component.exports